module.exports = __webpack_public_path__ + "img/credit-card-icon.fbb29ad5.png";